module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.52d98941.jpg";